module.exports = __webpack_public_path__ + "annualreview2017/static/img/investors-people@2x.18090a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/investors-people@2x.png
// module id = 88
// module chunks = 0